<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Anexar Recibo</span>
      </v-card-title>

      <div class="text-xs-center">
        <p class="success" v-if="successStatus">Arquivo enviado com sucesso!</p>
        <p class="error" v-if="errorStatus">{{errorMessage}}</p>
        <v-progress-circular v-if="load"
          :indeterminate="load"
          color="primary"
        ></v-progress-circular>
      </div>
      <v-card-text>
        <v-container>
          <label>Arquivo
            <input
              type="file"
              id="file"
              name="files"
              ref="file"
              accept="image/*,.pdf"
            />
            <v-text-field
              v-model="description"
              id="desciption"
              label="Descrição"
              onkeyup="setDescription(this.value)"
              single-line
              outlined
            ></v-text-field>
          </label>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click="setDialog()">Fechar</v-btn>
        <v-btn color="green darken-1" text @click="sendReceipt()">Enviar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import moment from 'moment';
import { mapGetters, mapActions } from 'vuex';
import { changed } from '@/helpers/layout';

export default {
  name: 'Modal',
  data() {
    return {
      fileBase64: '',
      description: '',
    };
  },
  created() {

  },
  computed: {
    ...mapGetters({
      load: 'chargebacks/load',
      errorStatus: 'chargebacks/errorStatus',
      successStatus: 'chargebacks/successStatus',
      errorMessage: 'chargebacks/errorMessage',
      sendReceiptResponse: 'chargebacks/sendReceiptResponse',
      dialog: 'chargebacks/dialog',
      id: 'chargebacks/id',
      loadFile: 'chargebacks/loadFile',
      fileConverted: 'chargebacks/fileConverted',
    }),
    pages() {
      return 0;
    },
  },
  components: {

  },
  watch: {

  },
  methods: {
    setDescription(value) {
      this.description = document.getElementById("escription").innerHTML = value;
    },
    setDialog() {
      if (this.dialog == false) {
        this.$store.commit('chargebacks/DIALOG', true);
      } else {
        this.$store.commit('chargebacks/DIALOG', false);
      }
    },
    sendReceipt() {
      this.file = this.$refs.file.files[0];
      const formData = new FormData();
      formData.append('id', this.id);
      formData.append('description', this.description);
      formData.append('receipt', this.file);
      this.$store.dispatch('chargebacks/sendReceipt', formData)
    },
    handleFiles() {
      this.$store.commit('chargebacks/LOAD_FILE', true);
      this.file = this.$refs.file.files[0];
      this.getBase64(this.file)
    },
    getBase64(file) {
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        // console.log('Read: '+reader.result);
      };
      reader.onerror = function (error) {
        // console.log('Error: '+error);
      };
      this.fileBase64 = reader.readAsText(file);
    }
  },
};
</script>
<style>
  .v-chip.invoice.false    { background-color: #B71C1C !important; }
  .v-chip.invoice.true    { background-color: #1B5E20 !important; }
</style>
